import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import * as css from './charge-point-list.module.scss';

export interface ChargePointListIsLockedCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['isLocked']
  > {}

const getChargePointIsLockedUiProperties = (
  value: boolean,
): { labelKey: string; color: string; icon: string } => {
  if (value) {
    return {
      labelKey: 'delmonicos-shared-sdk.outputs-charge-point-is-locked.TRUE',
      color: 'bg-surface-secondary',
      icon: 'terminal-maintenance',
    };
  }
  return {
    labelKey: 'delmonicos-shared-sdk.outputs-charge-point-is-locked.FALSE',
    color: 'bg-surface-success',
    icon: 'electric-terminal',
  };
};

export const ChargePointListIsLockedCell = (
  props: ChargePointListIsLockedCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();
  const { labelKey, color, icon } = getChargePointIsLockedUiProperties(value);

  return (
    <Tag justifyContent="center" className={classNames(color, css.statusTag)}>
      <Icon name={icon} />
      <Stack flex="1" justifyContent="center">
        <Text italic fontSize={TextFontSize.Small}>
          {t(labelKey)}
        </Text>
      </Stack>
    </Tag>
  );
};
